import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
import type { ProductsResponse } from "@/api/types/paymentGateway";
import { queryKeys } from "@/lib/queryClient";
import { getProducts } from "../../../api/endpoints/paymentGateway";

type GetProductsQueryKey = ReturnType<typeof queryKeys.paymentGateway.products>;

type UseGetProductsOptions = Omit<
  UseQueryOptions<
    ProductsResponse,
    Error,
    ProductsResponse,
    GetProductsQueryKey
  >,
  "queryKey" | "queryFn"
>;

export function useGetProducts(config?: UseGetProductsOptions) {
  return useQuery<
    ProductsResponse,
    Error,
    ProductsResponse,
    GetProductsQueryKey
  >({
    queryKey: queryKeys.paymentGateway.products(),
    queryFn: getProducts,
    staleTime: 5 * 60 * 1000,
    ...config,
  });
}
